import { render, staticRenderFns } from "./TrainGalleryManageAdd.vue?vue&type=template&id=32581044"
import script from "./TrainGalleryManageAdd.vue?vue&type=script&lang=js"
export * from "./TrainGalleryManageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports